module.exports = __webpack_public_path__ + "img/close-icon.626aa26f.svg";